import api from './api';

const procurementDashboardService = {
  // Get procurement dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/procurement-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching procurement dashboard stats:', error);
      throw error;
    }
  }
};

export default procurementDashboardService;

